import { render, staticRenderFns } from "./AddDressBrand.vue?vue&type=template&id=03b347ff&scoped=true"
import script from "./AddDressBrand.vue?vue&type=script&lang=js"
export * from "./AddDressBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b347ff",
  null
  
)

export default component.exports